import React from 'react'

const RealTimeTrackIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 16.933 16.933"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
            >
                <g>
                    <g fill="#ff9751">
                        <path
                            d="M14.287 9.035v.529h.53v-.53zM14.287 10.003v.53h.53v-.53zM14.287 12.034v.53h.53v-.53zM14.287 13v.124c0 .187-.02.266-.033.351l.52.102c.021-.122.043-.249.043-.445v-.133zM14.106 13.905c-.021.04-.059.113-.114.193-.056.08-.1.136-.145.186l.395.353c.034-.038.116-.136.189-.241.072-.105.147-.253.147-.253zM13.499 14.58c-.02.015-.111.068-.212.115-.1.047-.202.078-.202.078l.159.505a2.5 2.5 0 0 0 .269-.104c.11-.048.274-.149.274-.149zM12.176 14.808l-.115.516c.232.053.413.058.533.056l.063-.002a12.75 12.75 0 0 1-.02-.528 1.893 1.893 0 0 1-.23-.006c-.106-.009-.178-.026-.23-.036zM11.38 14.377l-.364.385c.08.073.13.118.193.164.039.027.054.04.121.085.07.047.114.069.17.103l.25-.468a1.659 1.659 0 0 1-.206-.132 1.542 1.542 0 0 1-.165-.137zM10.913 13.603l-.51.141s.032.124.096.272c.067.158.142.278.142.278l.455-.271a1.761 1.761 0 0 1-.11-.216c-.04-.09-.058-.162-.073-.204zM10.776 4.627l-.511.136c.044.184.055.308.055.458l.528-.001a2.241 2.241 0 0 0-.072-.593zM10.319 5.649v.529h.53v-.53zM10.319 6.59v.529h.53v-.53zM10.319 9.617v.53h.53v-.53zM10.319 12.622v.532c.205-.003.353-.003.53-.003v-.53zM10.186 3.6c-.132.131-.25.252-.374.377.106.105.195.218.28.363l.457-.266a2.406 2.406 0 0 0-.363-.474zM9.152 3.017l-.13.516c.133.028.302.096.425.168l.26-.46a2.18 2.18 0 0 0-.555-.224zM8.56 2.95a2.436 2.436 0 0 0-.592.089l.147.508c.148-.041.296-.066.454-.066zM7.421 3.282a2.15 2.15 0 0 0-.464.378l.386.363c.11-.12.223-.207.355-.29zM6.61 4.145a2.16 2.16 0 0 0-.205.563l.516.115c.042-.186.09-.294.157-.43zM6.35 5.291v.527h.53v-.527zM6.35 6.35v.53h.53v-.53zM6.35 7.407v.53h.53v-.53zM6.35 8.467v.53h.53v-.53zM6.35 9.525v.529h.53v-.53zM10.319 7.635v.53h.529v-.53zM10.319 8.632v.545h.529v-.545zM10.319 11.626v.53h.53v-.53zM14.28 8.03v.53h.529v-.53zM10.319 10.593v.53h.53v-.53zM14.287 11.016v.529h.53v-.53zM14.28 7.07v.53h.529v-.53z"
                            fill="#ff9751"
                            opacity={1}
                            data-original="#ff9751"
                        />
                    </g>
                    <path
                        fill="#e4eff8"
                        d="M5.556 4.498a2.381 2.381 0 1 1-4.762 0 2.381 2.381 0 0 1 4.762 0z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M3.175 2.117a2.381 2.381 0 0 0-2.381 2.38 2.381 2.381 0 0 0 .986 1.928 2.381 2.381 0 0 1-.457-1.398 2.381 2.381 0 0 1 2.381-2.381A2.381 2.381 0 0 1 5.1 3.1a2.381 2.381 0 0 0-1.924-.983z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#549ad4"
                        d="M3.176 2.91a1.59 1.59 0 0 0-1.123 2.71 1.588 1.588 0 0 0 2.709-1.123.265.265 0 0 0-.264-.265H3.44V3.176a.265.265 0 0 0-.264-.266zM3.44 1.058h-.53v1.059h.53z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#549ad4"
                        d="M3.704 1.323c.354 0 .354-.53 0-.53H2.646c-.354 0-.354.53 0 .53zM5.021 1.85a.265.265 0 0 0-.181.08l-.264.263a.265.265 0 1 0 .373.375l.266-.263a.265.265 0 0 0-.194-.455zM1.32 1.85a.265.265 0 0 0-.183.455l.263.263c.25.25.625-.125.375-.375L1.51 1.93a.265.265 0 0 0-.19-.08z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#549ad4"
                        d="M5.023 1.584a.265.265 0 0 0-.183.455l.265.266a.265.265 0 1 0 .374-.375l-.264-.266a.265.265 0 0 0-.192-.08zM1.318 1.584a.265.265 0 0 0-.181.08L.87 1.93c-.25.25.125.625.375.375l.264-.266a.265.265 0 0 0-.192-.455z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#3588cb"
                        d="M2.91 2.934v1.298h.53V3.176a.265.265 0 0 0-.264-.266c-.09 0-.179.009-.266.024zM4.209 4.232c-.09.533-.445.993-.955 1.204a1.587 1.587 0 0 1-1.431-.114c.064.106.139.208.23.299a1.588 1.588 0 0 0 2.709-1.123.265.265 0 0 0-.264-.266z"
                        opacity={1}
                        data-original="#3588cb"
                    />
                    <path
                        fill="#549ad4"
                        d="M3.176 1.852A2.651 2.651 0 0 0 .529 4.498a2.651 2.651 0 0 0 2.647 2.647A2.65 2.65 0 0 0 5.82 4.498a2.65 2.65 0 0 0-2.644-2.646zm0 .529c1.172 0 2.115.945 2.115 2.117a2.112 2.112 0 0 1-2.115 2.117 2.114 2.114 0 0 1-2.117-2.117c0-1.172.945-2.117 2.117-2.117zM13.328 4.976c-.262.11-.476.268-.572.47-.12.248-.04.5.142.683.316.315.968.486 1.654.486.687 0 1.34-.17 1.655-.486.182-.183.258-.436.142-.684-.097-.203-.31-.36-.572-.469-.314-.125-.538.33-.203.489.192.08.275.165.297.21.01.022-.003.042-.04.08-.172.174-.674.33-1.279.33-.605 0-1.106-.156-1.279-.33-.035-.038-.05-.058-.039-.08.021-.045.105-.13.297-.21.293-.14.158-.505-.09-.51a.286.286 0 0 0-.113.021z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#549ad4"
                        d="M14.55.53c1.024 0 1.854.856 1.854 1.898 0 .719-.432 1.451-.842 2.035-.41.583-.82 1.012-.82 1.012a.265.265 0 0 1-.38 0s-.412-.429-.821-1.012c-.41-.584-.842-1.316-.842-2.035 0-1.042.828-1.899 1.852-1.899z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#e4eff8"
                        d="M14.55 1.588c.435 0 .796.358.796.793a.795.795 0 0 1-1.588 0c0-.435.358-.793.793-.793z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#3588cb"
                        d="M16.404 2.428c0 .719-.432 1.451-.842 2.035-.41.583-.82 1.012-.82 1.012a.265.265 0 0 1-.38 0s-.171-.183-.394-.455c.089.02.182-.009.245-.075 0 0 .41-.428.82-1.011s.842-1.317.842-2.035c0-.393-.119-.76-.32-1.064.51.34.85.928.85 1.593z"
                        opacity={1}
                        data-original="#3588cb"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M15.309 2.155a.777.777 0 0 0-.23-.038.796.796 0 0 0-.792.793c0 .079.015.153.037.225a.792.792 0 0 1-.566-.754c0-.435.358-.793.793-.793.356 0 .658.241.758.567z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#ff9751"
                        d="M6.35 10.848v.53h.53v-.53zM1.322 11.642c-.288 0-.53.24-.53.529v3.176c0 .288.242.529.53.529h3.44c.288 0 .53-.24.53-.53v-3.175a.534.534 0 0 0-.53-.53z"
                        opacity={1}
                        data-original="#ff9751"
                    />
                    <path
                        fill="#549ad4"
                        d="M5.028 12.17a.265.265 0 0 0-.267.264v3.176c0 .148.12.267.267.266h2.908a.265.265 0 0 0 .266-.266V13.76a.265.265 0 0 0-.078-.188L7.066 12.25a.265.265 0 0 0-.187-.078z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#3588cb"
                        d="M7.673 13.007v2.603a.265.265 0 0 1-.266.266h.53a.265.265 0 0 0 .265-.266V13.76a.265.265 0 0 0-.078-.188z"
                        opacity={1}
                        data-original="#3588cb"
                    />
                    <path
                        fill="#ff7f29"
                        d="M1.473 15.567c0 .106.022.211.063.309h1.462a.794.794 0 1 0-1.525-.309z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#ff7f29"
                        d="M.793 15.347c0 .288.24.529.53.529H4.76c.289 0 .53-.24.53-.53v-3.175a.534.534 0 0 0-.529-.53v2.911c0 .289-.241.53-.53.53H.793z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#549ad4"
                        d="M5.292 15.875H.794c-.353 0-.353-.53 0-.53h4.498c0 .265-.002.265 0 .53z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#e4eff8"
                        d="M2.117 11.642v1.322c0 .187.19.316.363.246l.563-.225.562.225a.265.265 0 0 0 .364-.246v-1.322H2.117zM6.086 12.436a.265.265 0 0 0-.265.264v1.059c0 .146.12.264.265.263h1.48a.265.265 0 0 0 .187-.45l-.846-1.058a.265.265 0 0 0-.187-.078z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#3588cb"
                        d="M5.707 15.567c0 .106.021.211.063.309h1.462a.794.794 0 1 0-1.525-.309z"
                        opacity={1}
                        data-original="#3588cb"
                    />
                    <path
                        fill="#549ad4"
                        d="M7.408 15.61a.794.794 0 1 1-1.587 0 .794.794 0 0 1 1.587 0z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#3588cb"
                        d="M6.845 14.851a.794.794 0 0 1 .034.23.794.794 0 0 1-.794.794.794.794 0 0 1-.23-.035.794.794 0 0 0 .76.564.794.794 0 0 0 .793-.794.794.794 0 0 0-.563-.759z"
                        opacity={1}
                        data-original="#3588cb"
                    />
                    <path
                        fill="#e4eff8"
                        d="M6.88 15.61a.265.265 0 1 1-.53 0 .265.265 0 0 1 .53 0z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M6.8 15.423a.794.794 0 0 1-.373.374.265.265 0 1 0 .374-.374zM3.44 11.642v1.322a.265.265 0 0 1-.053.159l.218.087a.265.265 0 0 0 .364-.246v-1.322h-.265z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M2.117 12.434v.53a.265.265 0 0 0 .363.246l.563-.225.562.225a.265.265 0 0 0 .364-.246v-.53a.265.265 0 0 1-.364.247l-.562-.225-.563.225a.265.265 0 0 1-.363-.247z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#3588cb"
                        d="M1.505 15.345a.794.794 0 0 0-.032.222.794.794 0 0 0 .063.307h1.463a.794.794 0 0 0 .062-.307.794.794 0 0 0-.033-.222z"
                        opacity={1}
                        data-original="#3588cb"
                    />
                    <path
                        fill="#549ad4"
                        d="M3.175 15.61a.794.794 0 1 1-1.587 0 .794.794 0 0 1 1.587 0z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#3588cb"
                        d="M2.646 15.081a.794.794 0 0 1-1.024.76.794.794 0 1 0 .99-.99.793.793 0 0 1 .034.23z"
                        opacity={1}
                        data-original="#3588cb"
                    />
                    <path
                        fill="#e4eff8"
                        d="M2.646 15.61a.265.265 0 1 1-.53 0 .265.265 0 0 1 .53 0z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M2.194 15.797a.265.265 0 1 0 .373-.374.794.794 0 0 1-.373.374zM6.086 12.436a.265.265 0 0 0-.265.264v1.059c0 .146.12.264.265.263h.264v-.793c0-.146.12-.264.266-.263h.633c.008 0 .015.004.023.005l-.365-.456a.265.265 0 0 0-.187-.078z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                </g>
            </svg>

        </>
    )
}

export default RealTimeTrackIcon